import React, { useState, useEffect, useRef } from "react";
import { Link, useNavigate } from "react-router-dom";
import logoimg from '../Images/logonew (2).png';
import Allcourse from '../Course/Allcourse'; // Assuming this is the category dropdown
import config from '../../config/config';
import axios from 'axios';
import { FiSearch, FiBell, FiGrid, FiEdit3, FiUser, FiMenu, FiChevronDown, FiX } from 'react-icons/fi';
import GoalSelector from './GoalSelector';
import ExploreMenu from './ExploreMenu';

const Tophead = () => {
    const [navCourses, setNavCourses] = useState([]);
    const [scrolled, setScrolled] = useState(false);
    const [searchQuery, setSearchQuery] = useState("");
    const [showGoalSelector, setShowGoalSelector] = useState(false);
    const [showExploreMenu, setShowExploreMenu] = useState(false);
    const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

    const [allColleges, setAllColleges] = useState([]);
    const [showSuggestions, setShowSuggestions] = useState(false);

    // Refs for click outside to close
    const goalRef = useRef(null);
    const exploreRef = useRef(null);
    const searchRef = useRef(null);

    const navigate = useNavigate();

    // Fetch Nav Courses & Colleges
    useEffect(() => {
        const fetchData = async () => {
            try {
                const [navResponse, collegeResponse] = await Promise.all([
                    axios.get(`${config.API_BASE_URL}/api/admin/get_allNavCourse`),
                    axios.get(`${config.API_BASE_URL}/api/admin/get_collegespage`)
                ]);
                setNavCourses(navResponse.data.allnavCourse || []);
                setAllColleges(collegeResponse.data.collegePages || []);
            } catch (error) {
                console.error("Error fetching data:", error);
            }
        };
        fetchData();
    }, []);

    // Handle Scroll - Fix for Flashing
    useEffect(() => {
        const handleScroll = () => {
            setScrolled(window.scrollY > 10);
        };
        window.addEventListener('scroll', handleScroll);
        return () => window.removeEventListener('scroll', handleScroll);
    }, []);

    // Click Outside Handlers
    useEffect(() => {
        const handleClickOutside = (event) => {
            if (goalRef.current && !goalRef.current.contains(event.target)) {
                setShowGoalSelector(false);
            }
            if (exploreRef.current && !exploreRef.current.contains(event.target)) {
                setShowExploreMenu(false);
            }
            // Close search suggestions if clicked outside
            if (searchRef.current && !searchRef.current.contains(event.target)) {
                setShowSuggestions(false);
            }
        };
        document.addEventListener("mousedown", handleClickOutside);
        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, []);

    const handleSearch = (e) => {
        e.preventDefault();
        if (searchQuery.trim()) {
            navigate(`/TopUniversitiesandColleges?search=${encodeURIComponent(searchQuery)}`);
            setMobileMenuOpen(false);
            setShowSuggestions(false);
        }
    };

    const fallbackCourses = [
        'B.TECH', 'MBA', 'M.TECH', 'MBBS', 'B.COM', 'B.SC', 'B.SC(NURSING)',
        'BA', 'BBA', 'BCA', 'B.ARCH', 'B.ED', 'B.PHARMA', 'B.SC(AGRICULTURE)',
        'BAMS', 'LLB', 'LLM', 'M.PHARMA', 'M.SC', 'MCA', 'BPT', 'B.DES',
        'M.PLANNING', 'B.PLANNING', 'AGRICULTURE', 'ARTS', 'COMMERCE',
        'DESIGN', 'ENGINEERING', 'LAW', 'MANAGEMENT', 'MEDICAL',
        'PARAMEDICAL', 'PHARMACY', 'SCIENCE', 'ARCHITECTURE', 'AVIATION',
        'DENTAL', 'EDUCATION', 'HOTEL MANAGEMENT', 'MASS COMM', 'VETERINARY',
        'ANIMATION'
    ];

    return (
        <>

            <header className="fixed top-0 left-0 right-0 w-full z-[100] transform-none">
                {/* Background Layer - Smooth Opacity Transition */}
                <div
                    className={`absolute inset-0 bg-slate-900 transition-opacity duration-300 pointer-events-none ${scrolled ? 'opacity-95 shadow-lg backdrop-blur-md' : 'opacity-0'}`}
                ></div>
                {/* Gradient Overlay for initial state */}
                <div
                    className={`absolute inset-0 bg-gradient-to-r from-slate-900 via-blue-900 to-slate-900 transition-opacity duration-300 pointer-events-none ${scrolled ? 'opacity-0' : 'opacity-100'}`}
                ></div>

                {/* Top Bar: Logo, Search, User Actions */}
                <div className="container relative mx-auto px-4 py-3">
                    <div className="flex items-center justify-between gap-4">

                        {/* Left: Logo */}
                        <div className="flex items-center gap-4">
                            <Link to="/" className="flex-shrink-0">
                                <img src={logoimg} alt="Get Fast Education" className="h-10 md:h-12 lg:h-14 w-auto object-contain brightness-0 invert" />
                            </Link>

                            {/* Goal Selector (Desktop) */}
                            <div className="relative hidden lg:block" ref={goalRef}>
                                <div
                                    onClick={() => setShowGoalSelector(!showGoalSelector)}
                                    className="flex flex-col text-white cursor-pointer hover:bg-white/10 px-3 py-1 rounded transition select-none"
                                >
                                    <span className="text-xs text-orange-400 font-semibold uppercase tracking-wider">Select Goal & City</span>
                                    <div className="flex items-center gap-1 font-bold text-sm">
                                        <span>Select Goal</span>
                                        <FiChevronDown className={`transition-transform duration-300 ${showGoalSelector ? 'rotate-180' : ''}`} />
                                    </div>
                                </div>
                                {/* Dropdown Component */}
                                <GoalSelector isOpen={showGoalSelector} onClose={() => setShowGoalSelector(false)} />
                            </div>
                        </div>

                        {/* Center: Search Bar (Hidden on Mobile) */}
                        <div className="hidden lg:block flex-1 w-full max-w-2xl mx-4" ref={searchRef}>
                            <form onSubmit={handleSearch} className="relative group">
                                <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
                                    <FiSearch className="text-gray-400 group-focus-within:text-blue-600 transition-colors" size={20} />
                                </div>
                                <input
                                    type="text"
                                    className="block w-full pl-10 pr-4 py-2.5 rounded-md leading-5 bg-white text-gray-900 placeholder-gray-500 focus:outline-none focus:ring-2 focus:ring-orange-500 sm:text-sm shadow-inner transition-shadow"
                                    placeholder="Search for colleges, exams, courses, and more..."
                                    value={searchQuery}
                                    onChange={(e) => {
                                        setSearchQuery(e.target.value);
                                        setShowSuggestions(true);
                                    }}
                                    onFocus={() => setShowSuggestions(true)}
                                />
                                {/* Search Suggestions Dropdown */}
                                {showSuggestions && searchQuery.trim() && (
                                    <div className="absolute top-full left-0 right-0 bg-white rounded-b-xl shadow-2xl border-t border-gray-100 mt-2 max-h-96 overflow-y-auto z-50 animate-fade-in-down">
                                        {allColleges.filter(c =>
                                            c.collegeName?.toLowerCase().includes(searchQuery.toLowerCase()) ||
                                            c.city?.toLowerCase().includes(searchQuery.toLowerCase())
                                        ).length > 0 ? (
                                            allColleges.filter(c =>
                                                c.collegeName?.toLowerCase().includes(searchQuery.toLowerCase()) ||
                                                c.city?.toLowerCase().includes(searchQuery.toLowerCase())
                                            ).slice(0, 8).map((college) => (
                                                <div
                                                    key={college._id}
                                                    onClick={() => {
                                                        navigate(`/college/${college._id}`);
                                                        setSearchQuery('');
                                                        setShowSuggestions(false);
                                                    }}
                                                    className="px-4 py-3 hover:bg-orange-50 cursor-pointer border-b border-gray-50 last:border-0 flex items-center gap-4 transition-colors group"
                                                >
                                                    <div className="w-10 h-10 rounded-lg bg-gray-50 border border-gray-200 p-1 flex items-center justify-center flex-shrink-0">
                                                        <img
                                                            src={`${config.API_BASE_URL}/${college.image}`}
                                                            alt=""
                                                            className="w-full h-full object-contain mix-blend-multiply"
                                                        />
                                                    </div>
                                                    <div>
                                                        <p className="text-sm font-bold text-gray-800 group-hover:text-orange-600 transition-colors line-clamp-1">{college.collegeName}</p>
                                                        <p className="text-[10px] uppercase font-bold text-gray-400 tracking-wider">
                                                            {college.city}, {college.state}
                                                        </p>
                                                    </div>
                                                </div>
                                            ))
                                        ) : (
                                            <div className="p-6 text-center">
                                                <p className="text-sm font-semibold text-gray-500">No matching colleges found</p>
                                                <p className="text-xs text-gray-400 mt-1">Try checking your spelling or search for something else</p>
                                            </div>
                                        )}
                                        {/* Footer Action */}
                                        <div
                                            onClick={handleSearch}
                                            className="bg-gray-50 p-3 text-center cursor-pointer hover:bg-gray-100 transition border-t border-gray-100"
                                        >
                                            <span className="text-xs font-bold text-blue-600">View all results for "{searchQuery}"</span>
                                        </div>
                                    </div>
                                )}
                            </form>
                        </div>

                        {/* Right: Actions & Login */}
                        <div className="flex items-center gap-4">
                            {/* Desktop Actions */}
                            <div className="hidden lg:flex items-center gap-6 text-white">
                                <Link to="/review" className="flex items-center gap-2 text-sm font-medium hover:text-orange-400 transition">
                                    <FiEdit3 />
                                    <span>Write a Review</span>
                                </Link>

                                {/* Explore Menu */}
                                <div className="relative" ref={exploreRef}>
                                    <button
                                        onClick={() => setShowExploreMenu(!showExploreMenu)}
                                        className={`flex items-center gap-2 text-sm font-medium transition ${showExploreMenu ? 'text-orange-400' : 'hover:text-orange-400'}`}
                                    >
                                        <FiGrid />
                                        <span>Explore</span>
                                    </button>
                                    {/* Explore Mega Menu Component */}
                                    {showExploreMenu && <ExploreMenu onClose={() => setShowExploreMenu(false)} />}
                                </div>

                                <button className="text-white hover:text-orange-400 transition relative">
                                    <FiBell size={22} />
                                    <span className="absolute -top-1 -right-1 bg-red-500 text-[10px] w-4 h-4 rounded-full flex items-center justify-center font-bold">2</span>
                                </button>

                                {/* User Account / Navigation */}
                                <div className="flex items-center gap-2 ml-2">
                                    <div className="flex items-center bg-white/10 rounded-full p-1 pl-4 pr-1 border border-white/20 hover:bg-white/20 transition cursor-pointer">
                                        <Link to="/login" className="text-sm font-bold mr-3">Login / Sign Up</Link>
                                        <div className="bg-orange-500 p-2 rounded-full">
                                            <FiUser className="text-white" size={18} />
                                        </div>
                                    </div>
                                </div>
                            </div>

                            {/* Mobile Menu Toggle (Right Side) */}
                            <button
                                onClick={() => setMobileMenuOpen(true)}
                                className="lg:hidden text-white text-2xl p-1 hover:bg-white/10 rounded transition"
                            >
                                <FiMenu />
                            </button>
                        </div>
                    </div>
                </div>

                {/* Bottom Bar: Navigation Links (Desktop Only) */}
                <div className="hidden lg:block relative bg-black/20 backdrop-blur-sm border-t border-white/10">
                    <div className="container mx-auto px-4">
                        <div className="flex items-center gap-4">
                            {/* All Courses Dropdown */}
                            <div className="border-r border-white/10 pr-4 py-2">
                                <Allcourse />
                            </div>

                            {/* Scrolling Nav Links */}
                            <nav className="flex-1 overflow-x-auto scrollbar-hide">
                                <ul className="flex items-center space-x-6 py-3 whitespace-nowrap">
                                    {(navCourses.length > 0 ? navCourses : fallbackCourses).map((item, index) => {
                                        const name = typeof item === 'string' ? item : item.pageName;
                                        const link = typeof item === 'string' ? `/c_pages/${item}` : `/Collegespage/${item._id}`;
                                        return (
                                            <li key={index}>
                                                <Link
                                                    to={link}
                                                    className="text-sm font-medium text-gray-200 hover:text-white hover:underline decoration-orange-500 decoration-2 underline-offset-4 transition-all"
                                                >
                                                    {name}
                                                </Link>
                                            </li>
                                        );
                                    })}
                                </ul>
                            </nav>
                        </div>
                    </div>
                </div>
            </header>

            {/* Mobile Sidebar / Drawer */}
            {mobileMenuOpen && (
                <div className="fixed inset-0 z-[60] lg:hidden">
                    {/* Backdrop */}
                    <div
                        className="absolute inset-0 bg-black/50 backdrop-blur-sm"
                        onClick={() => setMobileMenuOpen(false)}
                    ></div>

                    {/* Sidebar Content */}
                    <div className="absolute top-0 left-0 bottom-0 w-4/5 max-w-sm bg-white shadow-2xl flex flex-col animate-slide-in">
                        <div className="p-4 bg-slate-900 text-white flex justify-between items-center">
                            <img src={logoimg} alt="Logo" className="h-8 brightness-0 invert" />
                            <button onClick={() => setMobileMenuOpen(false)} className="bg-white/10 p-2 rounded-full hover:bg-white/20 text-white">
                                <FiX size={20} />
                            </button>
                        </div>

                        <div className="flex-1 overflow-y-auto p-4 py-6 space-y-6">

                            {/* Auth Actions Mobile */}
                            <div className="bg-orange-50 p-4 rounded-xl border border-orange-100 mb-6">
                                <p className="text-gray-600 text-sm mb-3 font-medium">Access your account</p>
                                <Link to="/login" onClick={() => setMobileMenuOpen(false)} className="block w-full bg-orange-500 text-white text-center py-3 rounded-lg font-bold shadow-md hover:bg-orange-600 transition">
                                    Login / Sign Up
                                </Link>
                            </div>

                            {/* Quick Links */}
                            <div className="space-y-4">
                                <h3 className="text-sm font-bold text-gray-400 uppercase tracking-wider">Explore</h3>
                                <Link to="/review" onClick={() => setMobileMenuOpen(false)} className="flex items-center gap-3 text-gray-700 font-medium p-2 hover:bg-gray-50 rounded-lg transition">
                                    <FiEdit3 className="text-orange-500" /> Write a Review
                                </Link>
                                <Link to="/TopUniversitiesandColleges" onClick={() => setMobileMenuOpen(false)} className="flex items-center gap-3 text-gray-700 font-medium p-2 hover:bg-gray-50 rounded-lg transition">
                                    <FiGrid className="text-orange-500" /> Top Universities
                                </Link>
                            </div>

                            <hr className="border-gray-100" />

                            {/* All Courses List for Mobile */}
                            <div>
                                <h3 className="text-sm font-bold text-gray-400 uppercase tracking-wider mb-4">Browse Courses</h3>
                                <div className="grid grid-cols-2 gap-2">
                                    {(navCourses.length > 0 ? navCourses : fallbackCourses).slice(0, 16).map((item, index) => { // Limit for mobile view
                                        const name = typeof item === 'string' ? item : item.pageName;
                                        const link = typeof item === 'string' ? `/c_pages/${item}` : `/Collegespage/${item._id}`;
                                        return (
                                            <Link
                                                key={index}
                                                to={link}
                                                onClick={() => setMobileMenuOpen(false)}
                                                className="text-sm text-gray-600 p-2 bg-gray-50 rounded hover:bg-orange-50 hover:text-orange-600 transition truncate"
                                            >
                                                {name}
                                            </Link>
                                        );
                                    })}
                                </div>
                                <div className="mt-4 text-center">
                                    <Link to="/programs" onClick={() => setMobileMenuOpen(false)} className="text-orange-500 font-semibold text-sm hover:underline">View All Courses</Link>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            )}
        </>
    );
};

export default Tophead;
